import React from 'react'
import { UploadDashboard } from '../uppy/upload-dashboard'

const GB = 1024 * 1024 * 1024

export const TransferFileUploadAppVersion = ({ appVersion, onComplete }) => {
  if (!appVersion?.id) return null
  return (
    <UploadDashboard
      base={process.env.REACT_APP_API_STORAGE}
      path="api/v1/file-build-multipart"
      initParams={{ appVersionID: appVersion.id }}
      endpointGroup="build"
      targetId={`build:${appVersion.id}`}
      // Enterprise app-store builds for MDM distribution (Intune/Jamf/etc.):
      // Windows (.exe/.msi/.msix/.appx), macOS (.dmg/.pkg), Android (.apk), iOS
      // (.ipa); .zip kept for generic/non-MDM archives. Backend has no type
      // allowlist, so this is a client-side UX gate to prevent wrong-file uploads.
      allowedFileTypes={['.zip', '.exe', '.msi', '.msix', '.appx', '.dmg', '.pkg', '.apk', '.ipa']}
      maxFileSize={5 * GB}
      onComplete={onComplete}
    />
  )
}
